import { FormikToggleField } from 'components/FormikToggleField/FormikToggleField';
import { useLocale } from 'containers/App/LocaleContext';
import type { FormikProps } from 'formik';
import type { JSX } from 'react';

interface EnabledValues {
  isEnabled: boolean;
}

interface Props<T extends EnabledValues> {
  formik: FormikProps<T>;
}

export const FormikVendorApiEnabledField = <T extends EnabledValues>(
  props: Props<T>,
): JSX.Element => {
  const {
    discoverySettings: {
      vendorsApi: {
        labels: { enabled: enabledMsg },
      },
    },
  } = useLocale();
  return (
    <FormikToggleField
      className='mb-4'
      formik={props.formik}
      name='isEnabled'
      messages={enabledMsg}
    />
  );
};
